import {BloodGroupsList} from "./BloodGroupsList";
import {BloodGroupsEdit} from "./BloodGroupsEdit";
import {BloodGroupsCreate} from "./BloodGroupsCreate";

export default {
    list: BloodGroupsList,
    create: BloodGroupsCreate,
    edit: BloodGroupsEdit
};
